import {
  List as ListCore,
  ListItem as ListItemCore,
  ListItemIcon as ListItemIconCore,
} from '@material-ui/core';

import * as lib from '~/dependencies';

export const List = lib.styled(ListCore)`
      width: 100%;
  `;

export const ListItem = lib.styled(ListItemCore)`
      display: flex;
      flex-direction: column;
      align-items: unset !important;
  `;

export const ListItemIcon = lib.styled(ListItemIconCore)`
      display: flex;
      justify-content: flex-end;
  `;

export const ContactDetails = lib.styled.div`
      display: flex;
      flex: 1;
      flex-direction: column;
      font-size: 12px;
  
      .start-icon {
          .MuiSvgIcon-root {
              fill: gold !important;
          }
      }
  
      .custom-chip {
          display: flex;
          justify-content: flex-start;
          align-items: center;
  
          .MuiChip-colorPrimary {
              background-color: #78bb5d !important;
              font-size: 10px !important;
          }
  
          .MuiChip-sizeSmall {
              margin-left: 5px;
              height: 15px !important;
          }
      }
  `;

export const ButtonOpenContactContainer = lib.styled.div`
      margin-bottom: 5px;
      color: #19b6f2;
      text-decoration: underline;
      cursor: pointer;

      spain {
        display: inline;
      }
  `;

export const TextLabelContainer = lib.styled.div`
      margin-bottom: 3px;
      color: #989898;
  `;

export const LabelContent = lib.styled.span`
      color: #6e6e6e !important;
      font-weight: bold;
      margin-right: 5px;
  `;

export const HorizontalContactList = lib.styled.div``;

export const Navigations = lib.styled.div`
      font-size: 10px;
      display: flex;
      align-items: center;
      position: absolute;
      top: 0;
      right: 0;
      margin-top: 7px;
      margin-right: 50px;

      svg {
        fill: #757575;
        width: 21px;
        cursor: pointer;
      }
  `;

export const InteractionsContainer = lib.styled.div`
      margin-top: 10px;
      border-width: 2px;
      font-size: 12px;
  
      .header {
          display: flex;
          flex-direction: row;
          align-items: center;
          background-color: #F0F0F2;
          height: 30px;
          margin-left: -16px;
          margin-right: -16px;
          color: #6e6e6e;
          font-weight: bold;
      }
  
      .header-title {
          display: flex;
          flex: 9;
          justify-content: center;

          span {
            margin-left: 15%;
          }

      }
  
      .header-favorite {
          display: flex;
          flex: 1;
          justify-content: flex-start
          align-items: center;
          cursor: pointer;
  
          .MuiSvgIcon-root {
              fill: gold !important;
          }
      }
  `;
